module.exports = __webpack_public_path__ + "img/record-new.10472085.svg";